<div class="row">
    <div class="col-xl-4">
        <div class="card card-box mb-5 pt-4">
            <div class="card-tr-actions">
                <div class="custom-checkbox custom-control p-0 mt-3">
                    <input type="checkbox" id="inputCheckbox51" class="custom-control-input">
                    <label class="custom-control-label" for="inputCheckbox51">&nbsp;</label>
                </div>
            </div>
            <div class="d-flex align-items-center px-4 mb-3">
                <div class="avatar-icon-wrapper rounded mr-3">
                    <div class="d-block p-0 avatar-icon-wrapper m-0 d-100">
                        <div class="rounded overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar1.jpg"/>
                        </div>
                    </div>
                </div>
                <div class="w-100">
                    <a [routerLink]="" class="font-weight-bold font-size-lg" title="...">Kate Winchester</a>
                    <span class="text-black-50 d-block pb-1">Freelance Designer, Mutual Inc.</span>
                    <div class="d-flex align-items-center pt-2">
                        <button class="btn btn-sm btn-primary mr-3 shadow-none">Chat</button>
                        <button class="btn btn-sm btn-neutral-success">View</button>
                    </div>
                </div>
            </div>
            <div class="my-3 font-size-sm p-3 mx-4 bg-secondary rounded-sm">
                <div class="d-flex justify-content-between">
                        <span class="font-weight-bold">
                            Email:
                        </span>
                    <span class="text-black-50">russotry@russo.com</span>
                </div>
                <div class="d-flex justify-content-between py-2">
                        <span class="font-weight-bold">
                            Job Description:
                        </span>
                    <span class="text-black-50">Project Manager</span>
                </div>
                <div class="d-flex justify-content-between">
                        <span class="font-weight-bold">
                            Location:
                        </span>
                    <span class="text-black-50">San Francisco, USA</span>
                </div>
            </div>
            <div class="d-flex flex-wrap mb-1 mx-2">
                <div class="w-50 p-3">
                    <button class="btn btn-gradient bg-night-sky text-left px-4 py-3 w-100 rounded-lg" type="button">
                        <div>
                            <i-feather class="h1 d-block mb-4 text-warning line-height-1"
                                       name="settings"></i-feather>
                            <div class="font-weight-bold font-size-lg">Reports</div>
                            <div class="font-size-md mb-1 opacity-8">Monthly Stats</div>
                        </div>
                    </button>
                </div>
                <div class="w-50 p-3">
                    <button class="btn btn-gradient bg-midnight-bloom text-left px-4 py-3 w-100 rounded-lg" type="button">
                        <div>
                            <i-feather class="h1 d-block mb-4 text-success line-height-1"
                                       name="grid"></i-feather>
                            <div class="font-weight-bold font-size-lg">Statistics</div>
                            <div class="font-size-md mb-1 opacity-8">Customers stats</div>
                        </div>
                    </button>
                </div>
                <div class="w-50 p-3">
                    <button class="btn btn-gradient bg-vicious-stance text-left px-4 py-3 w-100 rounded-lg" type="button">
                        <div>
                            <i-feather class="h1 d-block mb-4 text-danger line-height-1"
                                       name="users"></i-feather>
                            <div class="font-weight-bold font-size-lg">Projects</div>
                            <div class="font-size-md mb-1 opacity-8">Manage servers</div>
                        </div>
                    </button>
                </div>
                <div class="w-50 p-3">
                    <button class="btn btn-gradient bg-royal text-left px-4 py-3 w-100 rounded-lg" type="button">
                        <div>
                            <i-feather class="h1 d-block mb-4 text-first line-height-1"
                                       name="layers"></i-feather>
                            <div class="font-weight-bold font-size-lg">Tasks</div>
                            <div class="font-size-md mb-1 opacity-8">Pending items</div>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5 pt-4">
            <div class="card-tr-actions">
                <div class="custom-checkbox custom-control p-0 mt-3">
                    <input type="checkbox" id="inputCheckbox551" class="custom-control-input">
                    <label class="custom-control-label" for="inputCheckbox551">&nbsp;</label>
                </div>
            </div>
            <div class="d-flex align-items-center px-4 mb-3">
                <div class="avatar-icon-wrapper rounded mr-3">
                    <span class="badge badge-position badge-position--top-right badge-circle-inner badge-danger" tooltip="Offline">Offline</span>
                    <div class="rounded overflow-hidden d-100 bg-neutral-first font-size-lg text-center font-weight-bold text-first d-flex justify-content-center flex-column">
                        <span>TY</span>
                    </div>
                </div>
                <div class="w-100">
                    <a [routerLink]="" class="font-weight-bold font-size-lg" title="...">Kris Alexander</a>
                    <span class="text-black-50 d-block pb-1">Project Manager, Apple Inc.</span>
                    <div class="d-flex align-items-center pt-2">
                        <button class="btn btn-sm btn-primary mr-3 shadow-none">Chat</button>
                        <button class="btn btn-sm btn-neutral-success">View</button>
                    </div>
                </div>
            </div>
            <div class="divider my-3"></div>
            <div class="font-size-sm px-4 rounded-sm">
                <div class="d-flex justify-content-between">
                        <span class="font-weight-bold">
                            Email:
                        </span>
                    <span class="text-black-50">krisa@example.com</span>
                </div>
                <div class="d-flex justify-content-between py-2">
                        <span class="font-weight-bold">
                            Job Description:
                        </span>
                    <span class="text-black-50">Project Manager</span>
                </div>
                <div class="d-flex justify-content-between">
                        <span class="font-weight-bold">
                            Location:
                        </span>
                    <span class="text-black-50">Montreal, CA</span>
                </div>
            </div>
            <div class="divider mt-3 mb-2"></div>
            <div class="list-group list-group-flush">
                <a [routerLink]="" class="list-group-item bg-white border-0 list-group-item-action align-box-row">
                    <div class="align-box-row w-100">
                        <div class="mr-3">
                            <div class="bg-neutral-success text-center text-success font-size-xl d-50 rounded-circle">
                                <fa-icon [icon]="['far', 'bell']"></fa-icon>
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold d-block">Sales</div>
                            <small class="text-success">
                                <fa-icon [icon]="['fas', 'chevron-up']" class="text-success mr-1"></fa-icon>
                                <span>15.4% increase</span>
                            </small>
                        </div>
                        <div class="ml-auto card-hover-indicator align-self-center">
                            <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-lg"></fa-icon>
                        </div>
                    </div>
                </a>
                <div class="divider"></div>
                <a [routerLink]="" class="list-group-item bg-white border-0 list-group-item-action align-box-row">
                    <div class="align-box-row w-100">
                        <div class="mr-3">
                            <div class="bg-neutral-danger text-danger text-center font-size-xl d-50 rounded-circle">
                                <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold d-block">Income</div>
                            <small class="text-danger">
                                <fa-icon [icon]="['fas', 'arrow-up']" class="text-danger mr-1"></fa-icon>
                                <span>5.2% decrease</span>
                            </small>
                        </div>
                        <div class="ml-auto card-hover-indicator align-self-center">
                            <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-lg"></fa-icon>
                        </div>
                    </div>
                </a>
                <div class="divider"></div>
                <a [routerLink]="" class="list-group-item bg-white border-0 list-group-item-action align-box-row">
                    <div class="align-box-row w-100">
                        <div class="mr-3">
                            <div class="bg-neutral-warning text-warning text-center font-size-xl d-50 rounded-circle">
                                <fa-icon [icon]="['far', 'chart-bar']"></fa-icon>
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold d-block">Expenses</div>
                            <small class="text-warning">
                                <fa-icon [icon]="['fas', 'arrow-down']" class="text-warning mr-1"></fa-icon>
                                <span>5.2% down</span>
                            </small>
                        </div>
                        <div class="ml-auto card-hover-indicator align-self-center">
                            <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-lg"></fa-icon>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5 py-4">
            <div class="card-tr-actions">
                <div class="custom-checkbox custom-control p-0 mt-3">
                    <input type="checkbox" id="inputCheckbox5551" class="custom-control-input">
                    <label class="custom-control-label" for="inputCheckbox5551">&nbsp;</label>
                </div>
            </div>
            <div class="d-flex align-items-center px-4 mb-3">
                <div class="avatar-icon-wrapper rounded mr-3">
                    <div class="d-block p-0 avatar-icon-wrapper m-0 d-100">
                        <div class="rounded overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar3.jpg"/>
                        </div>
                    </div>
                </div>
                <div class="w-100">
                    <a [routerLink]="" class="font-weight-bold font-size-lg" title="...">Matteo Mcphee</a>
                    <span class="text-black-50 d-block pb-1">Frontend Developer, Stripe Inc.</span>
                    <div class="d-flex align-items-center pt-2">
                        <button class="btn btn-sm btn-primary mr-3 shadow-none">Chat</button>
                        <button class="btn btn-sm btn-neutral-success">View</button>
                    </div>
                </div>
            </div>
            <div class="font-size-sm p-3 my-3 bg-neutral-dark mx-4 rounded-sm">
                <div class="d-flex justify-content-between">
                        <span class="font-weight-bold">
                            Email:
                        </span>
                    <span class="text-black-50">matteo@mophee.com</span>
                </div>
                <div class="d-flex justify-content-between py-2">
                        <span class="font-weight-bold">
                            Job Description:
                        </span>
                    <span class="text-black-50">Frontend Developer</span>
                </div>
                <div class="d-flex justify-content-between">
                        <span class="font-weight-bold">
                            Location:
                        </span>
                    <span class="text-black-50">London, UK</span>
                </div>
            </div>
            <ul class="nav nav-second flex-column pt-2">
                <li class="nav-item">
                    <a [routerLink]="" class="nav-link px-4">
                        <div class="nav-link-icon">
                            <fa-icon [icon]="['far', 'building']"></fa-icon>
                        </div>
                        <span>Dashboard</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="" class="nav-link px-4 active">
                        <div class="nav-link-icon">
                            <fa-icon [icon]="['far', 'question-circle']"></fa-icon>
                        </div>
                        <span>Layouts</span>
                        <div class="ml-auto badge badge-warning">512</div>
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="" class="nav-link px-4 disabled">
                        <div class="nav-link-icon">
                            <fa-icon [icon]="['far', 'user-circle']"></fa-icon>
                        </div>
                        <span>Reports</span>
                    </a>
                </li>
                <li class="nav-item nav-item--header">
                    <span>Others</span>
                </li>
                <li class="nav-item">
                    <a [routerLink]="" class="nav-link px-4">
                        <div class="nav-link-icon">
                            <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                        </div>
                        <span>Components</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="" class="nav-link px-4">
                        <div class="nav-link-icon">
                            <fa-icon [icon]="['far', 'chart-bar']"></fa-icon>
                        </div>
                        <span>Services</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
